
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
export const supabase = createClient(supabaseUrl, supabaseKey);

// const supabaseUrl = 'https://jszgeoosgpozjlvohrjy.supabase.co';
// const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impzemdlb29zZ3Bvempsdm9ocmp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNDEyOTUsImV4cCI6MjA2NzcxNzI5NX0.PIQNP7k37tRmiQeW2FFSGh2xQ_qCf8c6vQtTSCH_7ec';

